import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-6 max-w-[900px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            {aboutData.title}
          </h2>
        </div>

        <div className="bg-background-50 rounded-3xl border border-background-200/70 p-8 md:p-10">
          <div className="space-y-5">
            {aboutData.paragraphs.map((text, idx) => (
              <p
                key={idx}
                className={`text-foreground-600 leading-relaxed ${
                  idx === aboutData.paragraphs.length - 1
                    ? 'text-lg font-heading font-semibold text-primary-600 text-center pt-2'
                    : 'text-base md:text-lg'
                }`}
              >
                {text}
              </p>
            ))}
          </div>

          <div className="mt-8 pt-6 border-t border-background-200/70 flex flex-wrap justify-center gap-6 md:gap-12">
            <div className="text-center">
              <div className="text-2xl font-bold text-primary-500 font-heading">2021</div>
              <div className="text-sm text-foreground-500 mt-1">创始年份</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-primary-500 font-heading">5万+</div>
              <div className="text-sm text-foreground-500 mt-1">影视资源</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-primary-500 font-heading">1000万+</div>
              <div className="text-sm text-foreground-500 mt-1">月活用户</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}